import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Model } from 'libx';
import { observable, computed } from 'mobx';
import { timestampToISO } from 'utils/grpcUtil';
import { maybeParseDate } from 'utils/dateUtil';
import { PromptDesignee as PromptDesigneeProto } from '@taxfyle/api-internal/internal/prompt_pb';

/**
 * Represents the designee for a prompt.
 */
var PromptDesignee = _defineProperty(_defineProperty(_defineProperty({}, PromptDesigneeProto.CLIENT, 'CLIENT'), PromptDesigneeProto.PROVIDER, 'PROVIDER'), PromptDesigneeProto.DESIGNEE_UNKNOWN, 'Unknown');
export var PromptDesigneeType = {
  CLIENT: 'CLIENT',
  PROVIDER: 'PROVIDER',
  UNKNOWN: 'Unknown'
};

/**
 * Prompt Type options, such as Yes/No, Document Upload, etc.
 */
export var PromptType = {
  Bool: 'BOOL',
  DocumentUpload: 'DOCUMENTS',
  Text: 'TEXT'
};
var Prompt = (_dec = observable.shallow, _class = /*#__PURE__*/function (_Model) {
  function Prompt() {
    var _this;
    _classCallCheck(this, Prompt);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Prompt, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor2, _this);
    _initializerDefineProperty(_this, "title", _descriptor3, _this);
    _initializerDefineProperty(_this, "description", _descriptor4, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor5, _this);
    _initializerDefineProperty(_this, "createdById", _descriptor6, _this);
    _initializerDefineProperty(_this, "answeredById", _descriptor7, _this);
    _initializerDefineProperty(_this, "deletedById", _descriptor8, _this);
    _initializerDefineProperty(_this, "designee", _descriptor9, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor10, _this);
    _initializerDefineProperty(_this, "dateAnswered", _descriptor11, _this);
    _initializerDefineProperty(_this, "dateDeleted", _descriptor12, _this);
    _initializerDefineProperty(_this, "question", _descriptor13, _this);
    _initializerDefineProperty(_this, "deleted", _descriptor14, _this);
    return _this;
  }
  _inherits(Prompt, _Model);
  return _createClass(Prompt, [{
    key: "job",
    get:
    /**
     * The prompt job.
     *
     * @returns {*}
     */
    function get() {
      return this.rootStore.jobStore.jobs.get(this.jobId);
    }

    /**
     * Whether the prompt is pending a response.
     */
  }, {
    key: "isPendingResponse",
    get: function get() {
      return !this.dateAnswered;
    }

    /**
     * Whether the current user is the creator of the prompt.
     */
  }, {
    key: "isCreator",
    get: function get() {
      var currentMember = this.rootStore.sessionStore.memberIn(this.workspaceId);
      return currentMember.userPublicId === this.createdBy.userPublicId;
    }

    /**
     * Whether the current user can to answer the prompt.
     */
  }, {
    key: "canAnswer",
    get: function get() {
      var currentMember = this.rootStore.sessionStore.memberIn(this.workspaceId);
      var hasAdminPermissionToAnswerPrompt = Boolean(currentMember === null || currentMember === void 0 ? void 0 : currentMember.hasAllPermissions(['ADMIN_JOB_UPDATE']));
      var isJobClosed = Boolean(this.job.completed);
      return this.isPendingResponse && !this.isCreator && !isJobClosed && (this.isDesignee || hasAdminPermissionToAnswerPrompt);
    }

    /**
     * Whether the current user is allowed to delete the prompt.
     */
  }, {
    key: "canDelete",
    get: function get() {
      var currentMember = this.rootStore.sessionStore.memberIn(this.workspaceId);
      var hasAdminPermissionToDeletePrompt = currentMember === null || currentMember === void 0 ? void 0 : currentMember.hasAllPermissions(['ADMIN_JOB_UPDATE']);
      var isJobClosed = this.job.status === 'CLOSED';
      return !this.dateDeleted && !isJobClosed && (!this.isDesignee || hasAdminPermissionToDeletePrompt);
    }

    /**
     * Whether the current user is the designee for this prompt.
     *
     * @returns {boolean}
     */
  }, {
    key: "isDesignee",
    get: function get() {
      var _this$job, _this$job$currentUser;
      return ((_this$job = this.job) === null || _this$job === void 0 ? void 0 : (_this$job$currentUser = _this$job.currentUserCollaborator) === null || _this$job$currentUser === void 0 ? void 0 : _this$job$currentUser.type) === this.designee;
    }

    /**
     * Ensures that the workspace member is (going to be) in the local collection.
     *
     * @param userId
     * @param userPublicId
     * @param workspaceId
     * @returns {null|*}
     */
  }, {
    key: "primeUser",
    value: function primeUser(userId, userPublicId, workspaceId) {
      return !userId || !userPublicId || !workspaceId ? null : this.rootStore.memberStore.setAndFetch({
        workspace_id: workspaceId,
        user_id: userId,
        user_public_id: userPublicId
      });
    }

    /**
     * Parses the DTO to model properties.
     */
  }, {
    key: "parse",
    value: function parse(attrs) {
      return {
        id: attrs.id,
        jobId: attrs.jobId,
        title: attrs.title,
        description: attrs.description,
        workspaceId: attrs.workspaceId,
        createdBy: this.primeUser(attrs.createdById, attrs.createdByPublicId, attrs.workspaceId),
        answeredBy: this.primeUser(attrs.answeredById, attrs.answeredByPublicId, attrs.workspaceId),
        deletedBy: this.primeUser(attrs.deletedById, attrs.deletedByPublicId, attrs.workspaceId),
        designee: PromptDesignee[attrs.designee],
        dateCreated: maybeParseDate(timestampToISO(attrs.dateCreated)),
        dateAnswered: maybeParseDate(timestampToISO(attrs.dateAnswered)),
        dateDeleted: maybeParseDate(timestampToISO(attrs.dateDeleted)),
        question: toQuestionDTO(attrs.id, attrs.title, attrs.description, attrs.question, attrs.answer),
        deleted: attrs.deleted
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "title", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createdById", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "answeredById", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deletedById", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "designee", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dateAnswered", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "dateDeleted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "question", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "deleted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "job", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "job"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPendingResponse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPendingResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCreator", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCreator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canAnswer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDelete", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canDelete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDesignee", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDesignee"), _class.prototype), _class);
export { Prompt as default };
function toQuestionDTO(promptId, title, description, question, answer) {
  var baseProperties = {
    id: promptId,
    question: title,
    description: description,
    isPendingResponse: !answer
  };
  if (question !== null && question !== void 0 && question.boolInput) {
    var _answer$boolValue;
    return _objectSpread(_objectSpread({}, baseProperties), {}, {
      type: 'BOOL',
      answer: answer === null || answer === void 0 ? void 0 : (_answer$boolValue = answer.boolValue) === null || _answer$boolValue === void 0 ? void 0 : _answer$boolValue.value
    });
  }
  if (question !== null && question !== void 0 && question.documentsInput) {
    var _answer$documentsValu;
    return _objectSpread(_objectSpread({}, baseProperties), {}, {
      type: 'DOCUMENTS',
      answer: answer === null || answer === void 0 ? void 0 : (_answer$documentsValu = answer.documentsValue) === null || _answer$documentsValu === void 0 ? void 0 : _answer$documentsValu.selectedDocumentsList.map(function (item) {
        return {
          id: item.id,
          documentId: item.linkedDocumentId
        };
      }),
      options: question.documentsInput.optionsList
    });
  }
  if (question !== null && question !== void 0 && question.textInput) {
    var _answer$textValue;
    return _objectSpread(_objectSpread({}, baseProperties), {}, {
      type: 'TEXT',
      answer: answer === null || answer === void 0 ? void 0 : (_answer$textValue = answer.textValue) === null || _answer$textValue === void 0 ? void 0 : _answer$textValue.value
    });
  }
  return undefined;
}
//# sourceMappingURL=Prompt.js.map
